import React, { createContext } from "react"

const ConfigContext = createContext({})

export function withFontSizeConfig(Component) {
  return function (props) {
    return (
      <ConfigContext.Consumer>
        {(configData) => <Component {...props} {...configData} />}
      </ConfigContext.Consumer>
    )
  }
}

export default class FontSizeConfigProvider extends React.Component {
  initialState = {
    labelFontSize: 14,
    axisTitleFontSize: 16,
    tickFontSize: 14,
    suppAxisTitleFontSize: 12, // For smaller plots on the live commercial dashboards
    suppTickFontSize: 10, // For smaller plots on the live commercial dashboards
  }

  constructor(props) {
    super(props)

    this.state = {
      labelFontSize: this.initialState.labelFontSize,
      axisTitleFontSize: this.initialState.axisTitleFontSize,
      tickFontSize: this.initialState.tickFontSize,
      suppAxisTitleFontSize: this.initialState.suppAxisTitleFontSize,
      suppTickFontSize: this.initialState.suppTickFontSize,
    }

    this.updateSize = this.updateSize.bind(this)
    this.updateLabelFontSize = this.updateLabelFontSize.bind(this)
    this.updateAxisTitleFontSize = this.updateAxisTitleFontSize.bind(this)
    this.updateTickFontSize = this.updateTickFontSize.bind(this)
    this.resetFontSize = this.resetFontSize.bind(this)
  }

  render() {
    return (
      <ConfigContext.Provider
        value={{
          ...this.state,
          updateLabelFontSize: this.updateLabelFontSize,
          updateAxisTitleFontSize: this.updateAxisTitleFontSize,
          updateTickFontSize: this.updateTickFontSize,
          resetFontSize: this.resetFontSize,
        }}
      >
        {this.props.children}
      </ConfigContext.Provider>
    )
  }

  updateSize(key, value) {
    this.setState({
      [key]: parseInt(value),
    })
  }

  updateLabelFontSize(val) {
    this.updateSize("labelFontSize", val)
  }

  updateAxisTitleFontSize(val) {
    this.updateSize("axisTitleFontSize", val)
  }

  updateTickFontSize(val) {
    this.updateSize("tickFontSize", val)
  }

  resetFontSize() {
    this.setState({
      labelFontSize: this.initialState.labelFontSize,
      axisTitleFontSize: this.initialState.axisTitleFontSize,
      tickFontSize: this.initialState.tickFontSize,
    })
  }
}
